import React from 'react';
import { observer } from 'mobx-react';
import { Col, Row } from 'reactstrap';
import './ResultsCard.scss';

interface IResultsCardProps {
  fields: any;
  result: any;
  comment?: string;
  children?: any;
}

export const ResultsCard = observer(({ children, fields, result, comment }: IResultsCardProps) => {

  return (
    <div className="usa-summary-box results-card pr-0 pl-3 pt-3 pb-3">
      <div className="results-header">
        <h3 className="section-header mr-3">Results</h3>
        {children ? children : null}
      </div>
      <Row noGutters>
        {fields.map((el, i) => (
          <Col key={`section-${i}`} className={`${el.className ? el.className : 'col-md-4'} mt-4`}>
            <div className="results-header-row">
              {el.section}&nbsp;
              {el.comment ? <span className="fw-normal">&nbsp;{comment}</span> : null}
            </div>
            {Object.entries(el.fields).map(([key, value]) => (
              <Row key={`field-${key}`} className="m-0">
                <Col className="nobr p-0">
                  <strong>{value}:&nbsp;</strong>
                </Col>
                <Col>{result[key] && !isNaN(Number(result[key])) ? result[key].toFixed(2) : result[key]}</Col>
              </Row>
            ))}
          </Col>
        ))}
      </Row>
    </div>
  );
});
